import axios from "axios";
import { getEnvVariables } from "../helpers";

const { REACT_APP_FAST_API_URL } = getEnvVariables();

const langchainApi = axios.create({
  baseURL: REACT_APP_FAST_API_URL,
  // baseURL: "http://localhost:8000",
});

langchainApi.interceptors.request.use((config) => {
  const urlParams = new URLSearchParams(window.location.search);
  const apiKey = urlParams.get("key");

  config.headers = {
    ...config.headers,
    ...(apiKey ? { "Patient-Surgery-Key": apiKey } : {}),
    // "Access-Control-Allow-Origin": "*",
    // authorization: token ? token : undefined,
  };

  return config;
});

export default langchainApi;
